<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock v-if="atelier.id || atelier.presence" title="Atelier">
        <template v-if="atelier.presence"
          ><v-alert type="success"
            >Vous avez participé à un atelier ou à un entretien ; vous pouvez
            désormais effectuer une nouvelle candidature ou suivre l'état des
            candidatures déjà déposées.</v-alert
          ></template
        >
        <template v-else
          ><v-alert type="success">Vous êtes inscrit(e) à un atelier</v-alert>
          Date et heure de début de l'atelier : {{ atelier.dateDebut }}<br />
          Campus : {{ atelier.campus.libelle }}<br />
          Lieu : {{ atelier.lieu }}<br />

          <v-btn
            x-small
            text
            style="float: right"
            color="purple lighten-1"
            @click="desinscrire()"
            >Je souhaite me désinscrire</v-btn
          ><br />
        </template>
      </BaseBlock>
      <BaseBlock v-else title="Inscription à un atelier">
        <v-alert type="info"
          >La participation à un atelier est requise pour la prise en compte de
          vos candidatures. Pour voir les ateliers disponibles, veuillez
          sélectionner le type de diplôme et le libellé de la formation que vous
          souhaitez intégrer.</v-alert
        >
        <ChoixAtelier @inscription="getAtelier"></ChoixAtelier
      ></BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ChoixAtelier from "@/components/ChoixAtelier";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";

export default {
  name: "InscriptionAtelier",
  components: { BaseBlock, ChoixAtelier },
  data() {
    return { atelier: {} };
  },
  methods: {
    async getAtelier() {
      try {
        const atelier = await ApiEtudiantRepository.getEtudiantAtelier();
        this.atelier = atelier;
      } catch (error) {
        error;
      }
    },
    async desinscrire() {
      try {
        await ApiEtudiantRepository.desinscrireEtudiantAtelier(this.atelier.id);
        this.atelier = {};
        this.$toast.success("Vous vous êtes désincrit de l'atelier");
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  created() {
    this.getAtelier();
  },
};
</script>
